type QueryParamObject = { [key: string]: string | string[] | number | Date }

export const objectToQueryString = (obj: QueryParamObject): string => {
  return Object.entries(obj)
    .filter(([key, value]) => value !== undefined && value !== null && value !== '') // Ignoramos claves sin valor.
    .map(([key, value]) => {
      const encodedKey = encodeURIComponent(key)
      if (Array.isArray(value)) {
        return `${encodedKey}=${value.map((item) => encodeURIComponent(item.toString())).join(',')}`
      }
      return `${encodedKey}=${encodeURIComponent(value.toString())}`
    })
    .join('&')
}
